export function determineFieldType(type) {

  if (type === 'DATE') {
    return 'datetime';
  } else if (type === 'FILE') {
    return 'null';
  }

  return 'string';

}

export function convertColumnsToFields(columns) {

  const options = [];

  for (let column of columns) {

    options.push({
      label: column.name,
      key: column.name,
      type: determineFieldType(column.type),
      customLoaderAvailable: true
    });

  }

  return options;

}